import {post} from '../utils/request'

export default {
    getUcKey: function () {
        return post("/admin/setting/uckey", {});
    },
    deleteById: function (id) {
        return post("/admin/report/del", {id});
    },
    getUseinfoCycle: function () {
        return post("/admin/setting/getUseinfoCycle", {});
    },
    updateUseinfoCycle: function (useinfoCycle) {
        return post("/admin/setting/updateUseinfoCycle", {useinfoCycle});
    }
}
